(() => {
  if (window.APC_CUSTOM_QUANTITY_FILTER) {
    window.APC_CUSTOM_QUANTITY_FILTER.initialiseWithin(document);
    return;
  }

  const initializedPickers = new WeakSet();
  const normalise = (value) => value.trim().toLowerCase();

  function initialisePicker(picker) {
    if (initializedPickers.has(picker)) return;

    const root = picker.closest(
      'product-info[data-custom-event-product]'
    );

    const variantsJson = picker.querySelector(
      '[data-product-variants]'
    );

    if (!root || !variantsJson) return;

    let variants;

    try {
      variants = JSON.parse(
        variantsJson.textContent
      );
    } catch (error) {
      console.error(
        'Unable to read custom-event product variants.',
        error
      );
      return;
    }

    const optionControls = Array.from(
      picker.querySelectorAll(
        'fieldset, .product-form__input--dropdown'
      )
    );

    const optionPositions = new Map();

    optionControls.forEach((control, index) => {
      const heading = control.querySelector(
        'legend, label.form__label'
      );

      if (heading) {
        optionPositions.set(
          normalise(heading.textContent),
          index
        );
      }
    });

    const bagSizePosition =
      optionPositions.get('bag size');

    const flavorPosition =
      optionPositions.get('flavor');

    const quantityPackPosition =
      optionPositions.get('quantity pack');

    if (
      bagSizePosition === undefined ||
      flavorPosition === undefined ||
      quantityPackPosition === undefined
    ) {
      return;
    }

    let filtering = false;

    const originalSelectOptions =
      new WeakMap();

    function getSelectedValue(position) {
      const control =
        optionControls[position];

      if (!control) return null;

      const checked = control.querySelector(
        'input[type="radio"]:checked'
      );

      if (checked) {
        return checked.value;
      }

      const select =
        control.querySelector('select');

      return select ? select.value : null;
    }

    function dispatchVariantChange(control) {
      control.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }

    function rebuildSelect(
      select,
      validValues
    ) {
      if (
        !originalSelectOptions.has(select)
      ) {
        originalSelectOptions.set(
          select,
          Array.from(
            select.options,
            (option) =>
              option.cloneNode(true)
          )
        );
      }

      const previousValue =
        select.value;

      const availableOptions =
        originalSelectOptions
          .get(select)
          .filter((option) =>
            validValues.has(option.value)
          )
          .map((option) =>
            option.cloneNode(true)
          );

      select.replaceChildren(
        ...availableOptions
      );

      if (!availableOptions.length) {
        return false;
      }

      const nextValue =
        validValues.has(previousValue)
          ? previousValue
          : availableOptions[0].value;

      select.value = nextValue;

      return nextValue !== previousValue;
    }

    function filterFlavor() {
      const selectedBagSize =
        getSelectedValue(
          bagSizePosition
        );

      if (!selectedBagSize) return;

      const validFlavors = new Set(
        variants
          .filter((variant) => {
            return (
              variant.available &&
              variant.options[
                bagSizePosition
              ] === selectedBagSize
            );
          })
          .map(
            (variant) =>
              variant.options[
                flavorPosition
              ]
          )
      );

      const flavorControl =
        optionControls[
          flavorPosition
        ];

      if (!flavorControl) return;

      const radios = Array.from(
        flavorControl.querySelectorAll(
          'input[type="radio"]'
        )
      );

      if (radios.length) {
        radios.forEach((radio) => {
          const label =
            flavorControl.querySelector(
              `label[for="${CSS.escape(
                radio.id
              )}"]`
            );

          const isValid =
            validFlavors.has(
              radio.value
            );

          if (label) {
            label.hidden = !isValid;
          }

          radio.disabled =
            !isValid;

          if (
            !isValid &&
            radio.checked
          ) {
            radio.checked = false;
          }
        });

        if (
          !flavorControl.querySelector(
            'input[type="radio"]:checked'
          )
        ) {
          const firstValid =
            radios.find((radio) =>
              validFlavors.has(
                radio.value
              )
            );

          if (firstValid) {
            firstValid.checked = true;

            dispatchVariantChange(
              firstValid
            );
          }
        }

        return;
      }

      const select =
        flavorControl.querySelector(
          'select'
        );

      if (!select) return;

      if (
        rebuildSelect(
          select,
          validFlavors
        )
      ) {
        dispatchVariantChange(
          select
        );
      }
    }

    function filterOptions() {
      if (filtering) return;

      filtering = true;

      try {
        filterFlavor();

        const selectedBagSize =
          getSelectedValue(
            bagSizePosition
          );

        const selectedFlavor =
          getSelectedValue(
            flavorPosition
          );

        if (!selectedBagSize) {
          return;
        }

        const validQuantityPacks =
          new Set(
            variants
              .filter((variant) => {
                return (
                  variant.available &&
                  variant.options[
                    bagSizePosition
                  ] ===
                    selectedBagSize &&
                  variant.options[
                    flavorPosition
                  ] ===
                    selectedFlavor
                );
              })
              .map(
                (variant) =>
                  variant.options[
                    quantityPackPosition
                  ]
              )
          );

        const quantityControl =
          optionControls[
            quantityPackPosition
          ];

        if (!quantityControl) {
          return;
        }

        const radios =
          Array.from(
            quantityControl.querySelectorAll(
              'input[type="radio"]'
            )
          );

        if (radios.length) {
          radios.forEach((radio) => {
            const label =
              quantityControl.querySelector(
                `label[for="${CSS.escape(
                  radio.id
                )}"]`
              );

            const isValid =
              validQuantityPacks.has(
                radio.value
              );

            if (label) {
              label.hidden = !isValid;
            }

            radio.disabled =
              !isValid;

            if (
              !isValid &&
              radio.checked
            ) {
              radio.checked = false;
            }
          });

          if (
            !quantityControl.querySelector(
              'input[type="radio"]:checked'
            )
          ) {
            const firstValid =
              radios.find((radio) =>
                validQuantityPacks.has(
                  radio.value
                )
              );

            if (firstValid) {
              firstValid.checked = true;

              dispatchVariantChange(
                firstValid
              );
            }
          }

          return;
        }

        const select =
          quantityControl.querySelector(
            'select'
          );

        if (!select) return;

        if (
          rebuildSelect(
            select,
            validQuantityPacks
          )
        ) {
          dispatchVariantChange(
            select
          );
        }
      } finally {
        filtering = false;
      }
    }

    picker.addEventListener(
      'change',
      () => {
        window.setTimeout(
          filterOptions,
          0
        );
      }
    );

    filterOptions();

    initializedPickers.add(
      picker
    );
  }

  function initialiseWithin(root) {
    if (
      !(
        root instanceof Element ||
        root instanceof Document
      )
    ) {
      return;
    }

    root
      .querySelectorAll(
        'product-info[data-custom-event-product] variant-selects'
      )
      .forEach(initialisePicker);
  }

  function start() {
    initialiseWithin(document);

    const observer =
      new MutationObserver(
        (mutations) => {
          mutations.forEach(
            (mutation) => {
              mutation.addedNodes.forEach(
                (node) => {
                  if (
                    !(
                      node instanceof
                      Element
                    )
                  ) {
                    return;
                  }

                  if (
                    node.matches(
                      'variant-selects'
                    )
                  ) {
                    initialisePicker(
                      node
                    );
                  }

                  initialiseWithin(
                    node
                  );
                }
              );
            }
          );
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  window.APC_CUSTOM_QUANTITY_FILTER = {
    initialiseWithin
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();